module.exports = __webpack_public_path__ + "assets/GoldEta2x.0bee51637a8655d4abef8858102bbcbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs2x-gold/GoldEta2x.png
// module id = 809
// module chunks = 0